import { AddTagsModal } from '@app/pages/Tags/components/AddTagsModal';
import { TagsPageHeader } from '@app/pages/Tags/components/TagsPageHeader';

export { TagsPageHeader, AddTagsModal };
